module.exports = __webpack_public_path__ + "img/iDash.1bb4d98d.jpg";